var methods = {
  //network: "http://67.229.230.130:9092",
  //newAPINetwork: "http://67.229.230.19092",
  //network: "http://zeyu-backend.local",
  //newAPINetwork: "http://zeyu-backend.local",
  network: "https://zeyuapi.com",
  newAPINetwork: "https://zeyuapi.com",

  /**
   * 时间戳->格式化时间
   */
  timeFormat: function(time, fmt = "yyyy-MM-dd hh:mm:ss") {
    return this.dateFormat(new Date(time * 1000), fmt);
  },

  /**
   * 时间->格式化时间
   */
  dateFormat: function(date = new Date(), fmt = "yyyy-MM-dd hh:mm:ss") {
    var weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    var o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "w": weeks[date.getDay()],
      S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
  },
  // 头部加密
  header(data = {}) {
    var header = publicParams(),
      signData = mergeMap([data, header]);
    // 签名
    header["sign"] = createSignVal(signData);
    if (localStorage.getItem("token")) {
      header["token"] = localStorage.getItem("token");
    }
    header['client']='pc'
    if(localStorage.getItem("url")){
      header["content-type"] = "multipart/form-data"
    }
    return header;
  },

  randomStr(len) {
    len = len || 32;
    var $chars =
      "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = "";
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }
};
// 通用请求
// var cm = (api = '', map = {}, config = {
//     id: '',
//     type: 'get'
// }) => {
//     let suffix = config.id && (config.id.length > 0 || config.id > 0) ? ('/' + config.id) : ''
//     return new Promise((resolve, reject) => {
//         resolve(request(config.type, api + suffix, map, false))
//     })
// }

// ****************************
// 参数
function createSignVal(map) {
  var sign = "";
  var arr = [];
  var index = 0;
  for (var prop in map) {
    if (map.hasOwnProperty(prop)) {
      arr[index] = prop;
    }
    index++;
  }
  arr.sort();
  for (var i = 0; i < arr.length; i++) {
    sign = sign + map[arr[i]];
  }
  return Base64.encode("0MCZpjag2XBnEahSGc3UFzhikBlJIAXx");
}

function publicParams() {
  var times = Date.parse(new Date()) / 1000;
  var random = randomString(32);
  var map = {};
  map["random"] = random;
  map["time"] = times;
  return map;
}

function mergeMap(mapArr) {
  var map = {};
  for (var index in mapArr) {
    let subMap = mapArr[index];

    for (var key in subMap) {
      map[key] = subMap[key];
    }
  }
  return map;
}

function randomString(len) {
  len = len || 32;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

//  base64
var Base64 = {
  // private property
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

  // public method for encoding
  encode: function(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output =
        output +
        this._keyStr.charAt(enc1) +
        this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) +
        this._keyStr.charAt(enc4);
    }

    return output;
  },

  // public method for decoding
  decode: function(input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = Base64._utf8_decode(output);

    return output;
  },

  // private method for UTF-8 encoding
  _utf8_encode: function(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }

    return utftext;
  },

  // private method for UTF-8 decoding
  _utf8_decode: function(utftext) {
    var string = "";
    var i = 0;
    var c = (c1 = c2 = 0);

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        i += 3;
      }
    }

    return string;
  }
};
export default methods;



// WEBPACK FOOTER //
// ./src/service/network.js